/* eslint-disable no-case-declarations */

import {
  ADDING_CATEGORY,
  ADDING_CATEGORY_SUCCESS,
  ADDING_CATEGORY_ERROR,

  UPDATING_CATEGORY,
  UPDATING_CATEGORY_SUCCESS,
  UPDATING_CATEGORY_ERROR,

  DELETING_CATEGORY,
  DELETING_CATEGORY_SUCCESS,
  DELETING_CATEGORY_ERROR,

  LOADING_CATEGORIES,
  LOADING_CATEGORIES_SUCCESS,
  LOADING_CATEGORIES_ERROR,

  UPDATING_CATEGORY_ORDER,
  UPDATING_CATEGORY_ORDER_SUCCESS,
  UPDATING_CATEGORY_ORDER_ERROR,
} from '../actions/categories';
  
  const initialState = {
    categoriesList: [],
    loading: false,
  };
  
const CategoriesReducer = (state = initialState, action) => {
    switch (action.type) {
      case ADDING_CATEGORY:
        return { ...state, loading: true };
  
      case ADDING_CATEGORY_SUCCESS:
        return {
          ...state,
          loading: false,
          categoriesList: [...state.categoriesList, action.payload],
        };

      case UPDATING_CATEGORY:
        return { ...state, loading: true };
  
      case UPDATING_CATEGORY_SUCCESS:
        const category = action.payload;
        const newCategories = state.categoriesList.map((obj) => {
          return category.id === obj.id ? category : obj;
        });
        return {
          ...state,
          loading: false,
          categoriesList: [...newCategories]
        };

      case DELETING_CATEGORY:
        return { ...state, loading: true };
  
      case DELETING_CATEGORY_SUCCESS:
        return {
          ...state,
          loading: false,
          categoriesList: [...state.categoriesList.filter((obj) => {
            const findObj = action.payload.find(removedCategory => (removedCategory.id === obj.id));
            if (findObj === undefined)
              return true;
            return (obj.id !== findObj.id);
          })],
          //categoriesList: [...state.categoriesList.filter((obj) => obj.id !== action.payload.id)],
          //categoriesChecks: [...state.categoriesChecks.filter((id) => id !== action.payload.id)]
        };

      case LOADING_CATEGORIES:
        return { ...state, loading: true };
  
      case LOADING_CATEGORIES_SUCCESS:
        return {
          ...state,
          loading: false,
          categoriesList: action.payload,
        };

      case UPDATING_CATEGORY_ORDER:
        return { ...state, loading: true };

      case UPDATING_CATEGORY_ORDER_SUCCESS:
        return {
          ...state,
          loading: false,
          categoriesList: action.payload,
        };

      // case UPDATING_CATEGORY_CHECKS:
      //   //console.log(action.payload)
      //   return {
      //     ...state,
      //     loading: false,
      //     categoriesChecks: [...action.payload],
      //   };

      // case DELETING_EVENT:
      //     return { ...state, loading: true };
    
      // case DELETING_EVENT_SUCCESS:
      //   return {
      //     ...state,
      //     loading: false,
      //     eventList: action.payload,
      //   };
  
      

      // case LOADING_TABLE:
      //   return { ...state, loading: true };
          
      // case LOADING_TABLES_SUCCESS:
      //   return {
      //       ...state,
      //       loading: false,
      //       tableInfo: action.payload.tableInfo,
      //   };

      default:
        return state;
    }
  };
  
  export default CategoriesReducer;
  